<template>
        <div>
            <span class="BtnSpan" v-if="ScopeRow.acclist&&ScopeRow.acclist.length == 0" @click="upLoadAccessory(ScopeRow)" type="text">{{$t('comm.uploadFile')}}</span>
            <span class="BtnSpan" v-else-if="ScopeRow.acclist&&ScopeRow.acclist.length > 0" @click="viewLoadedAcc(ScopeRow)" type="text">{{$t('comm.viewFile')}}</span>
            <div v-if="showdialog" >
                <el-dialog :title="$t('comm.viewFile')" :visible.sync="rowAccVisible" append-to-body>
                    <el-table :data="RowAccTableData"  height="50vh" ref="AccTable" v-loading="tableLoading">
                        <el-table-column type="index" :label="$t('comm.number')" width="100"></el-table-column>
                        <el-table-column prop="AccessoryName" :label="$t('Download.accessoryname')"></el-table-column>
                        <el-table-column prop="UploadTime" :label="$t('Download.recupdate')"></el-table-column>
                        <el-table-column width="160" :label="$t('DeliverCar.operation')">
                            <template slot-scope="scope">
                                <span class="BtnSpan" v-if="scope.row.AllowPreview" @click="viewAcc(scope.row)" type="text">{{$t('button.check')}}</span>
                                <span class="BtnSpan" v-if="scope.row.AllowDownload" @click="loadAcc(scope.row)" type="text">{{$t('button.download')}}</span>
                                <span class="delete" v-if="scope.row.AllowDelete" @click="delAcc(scope.row)" type="text">{{$t('button.delete')}}</span>
                                <span class="NoPower" v-if="!scope.row.AllowDelete&&!scope.row.AllowPreview&&!scope.row.AllowDownload">{{ $t('button.nopower') }}</span>
                            </template>
                          
                        </el-table-column>
                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="upLoadAccessory(ScopeRow)">{{ $t('comm.uploadFile') }}</el-button>
                    </div>
                </el-dialog>
                <DialogUpLoad :base="base" :visible.sync="uploadVisible" ref="DialogUpLoad" :isCanEdit.sync="isCanEdit" :uploadParams="uploadParams"  :AccessoryTypeName.sync="accessoryTypeName" v-on="$listeners" :AppendToBody="true"></DialogUpLoad>
            </div>
           
        </div>
</template>
<script>
//行项上传附件的窗口，用于查看行项附件和继续上传附件 
//作用页面：发货车页，发货详情页
import DialogUpLoad from './DialogUpLoad.vue';
import {PreviewAcc,deleteAcc,downloadAcc} from '@/utils/utils'
export default{
    model:{
        //双向绑定row值
        prop:'ScopeRow',
        event:'updateRow'
    },
    watch:{
        rowAccVisible:function(newVal,oldVal){
            //回收dom，以免页面渲染过多上传附件的窗口
            if(!newVal){
                    this.showdialog = false;
            }
        },
        uploadVisible:function(newVal){
            //回收dom，以免页面渲染过多上传附件的窗口
            if(!newVal && !this.rowAccVisible){
                    this.showdialog = false;
            }
        },
        'ScopeRow.acclist':function(newVal){
            //每次更新完acclist的数据，这边会进行一次自动刷新
            this.$nextTick(()=>{
                this.RowAccTableData = this.ScopeRow.acclist;
                if(this.$refs.AccTable)
                this.$refs.AccTable.doLayout();
            })
        }
    },
    components:{
        DialogUpLoad
    },
    props:{
        //行数据
        ScopeRow:{
            type:Object,
            default:()=>{
                return{acclist:[]};
            },
        },
        //获取progid，internalId等
        base:{
            type:Object,
            default:()=>{
                return{};
            },
        },
        //当前单据主键
        primaryKey:{
            type:Object,
            default:()=>{
                return{};
            },
        },
    },
    data(){
        return{
            rowAccVisible:false,
            isCanEdit:false,
            uploadParams:{},
            accessoryTypeName:'',
            showdialog:false,
            RowAccTableData:[],
            uploadVisible:false,
            tableLoading:false,
        }
    },
    methods:{
        // 呼出上传附件的窗口，主要的上传逻辑在'./DialogUpLoad.vue';
        upLoadAccessory(row){
            this.showdialog = true;
            this.ScopeRow = row;
            this.RowAccTableData = this.ScopeRow.acclist;
            if(!this.isCanEdit && this.permitStateName == this.$t('ReconciliationDetail.PermitState_2')){
                let tipMsg= this.$t('ReconciliationDetail.bill')+this.$t('ReconciliationDetail.PermitState_2')+","+this.$t('ReconciliationDetail.accessoryType')+"("+this.accessoryTypeName+")"+this.$t('ReconciliationDetail.canNotAddAccess');
                this.$alert(tipMsg, this.$t('comm.tip'), { confirmButtonText: this.$t('comm.confirm') });
                return;
            }
            this.uploadParams = {
                primaryKey: JSON.stringify(this.primaryKey),
                DetailRowAcc:true,
                RowCode:row.RowCode
            }
            this.$nextTick(()=>{
                this.uploadVisible = true;
            })
        },
        //呼出附件列表的窗口
        viewLoadedAcc(row){
            this.showdialog = true;
            this.$nextTick(()=>{
                this.rowAccVisible = true;
                this.ScopeRow = row;
                this.RowAccTableData = this.ScopeRow.acclist;
            })
        },
        //上传后执行的操作
        afterUpLoad(){   
            this.tableLoading = true;
            this.axiosInvoke("/SupplierComm/Handler/VueSysHandler.ashx", 
            {
                ProgId:this.base.progId,
                primaryKey: JSON.stringify(this.primaryKey),
                action:"getbillrowaccinfo",
                InternalId:this.base.InternalId,
                RowCode: this.ScopeRow.RowCode
            },(res)=>{
                let data = res.data;
                this.ScopeRow.acclist = data;
                this.tableLoading = false;
            });
        },
        viewAcc(row){
            if(row.AllowPreview){
                PreviewAcc(row.AccessoryId);
            }
        },
        delAcc(row){
            this.$msgbox({
                title:this.$t("comm.tip"),
                message:this.$t("comm.deleteFileTip"),
                showCancelButton:true
            }
            ).then(()=>{
                let delList = [];
                this.ScopeRow.acclist.forEach(v => {
                    if(v.AccessoryId == row.AccessoryId){
                        v.state = 3;
                        delList.push(v);
        }
                });
                deleteAcc.call(this,this.primaryKey,this.base.progId,delList,this.base.InternalId,true,this.ScopeRow.RowCode,this.afterUpLoad);
            });
        },
        loadAcc(row){
            downloadAcc.call(this,this.base.progId,this.base.InternalId,this.primaryKey,row);
        },
    }
}
</script>
<style scoped>

.BtnSpan{
    color:#409EFF;
    margin-right: 15px;
}
.BtnSpan:hover{
    cursor:pointer;
    color:#4385FF;
}
.delete{
    color: black;
    margin-right: 15px;
}
.delete:hover{
    cursor:pointer;
    color:#666666;
}
.NoPower{
    color: rgb(141, 141, 141);
}

</style>